import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { MagnifyingGlass } from "@phosphor-icons/react";
import { api, money } from "@/lib/api";

const GROUPS = [
  ["customers", "Customers", (r) => r.name, (r) => null],
  ["properties", "Properties", (r) => r.name || r.service_address, (r) => `/property/${r.id}`],
  ["equipment", "Equipment", (r) => `${r.nickname || r.model} ${r.manufacturer ? `· ${r.manufacturer}` : ""}`, (r) => (r.property_id ? `/property/${r.property_id}` : null)],
  ["jobs", "Jobs", (r) => `${r.customer_name || ""} — ${r.location || ""}`, (r) => `/job/${r.id}`],
  ["invoices", "Invoices", (r) => `${r.invoice_number} · ${r.customer_name} · ${money(r.total)}`, (r) => `/invoice/${r.id}`],
  ["receipts", "Receipts", (r) => `${r.store} · ${money(r.total)}`, (r) => `/receipt/scan?id=${r.id}`],
  ["stock", "Stock", (r) => `${r.name} · ${r.qty_on_hand} on hand`, (r) => "/stock"],
];

export const GlobalSearch = () => {
  const nav = useNavigate();
  const [q, setQ] = useState("");
  const [res, setRes] = useState(null);
  const timer = useRef();

  const run = (v) => {
    setQ(v);
    clearTimeout(timer.current);
    if (v.trim().length < 2) { setRes(null); return; }
    timer.current = setTimeout(async () => {
      try { setRes((await api.get(`/search?q=${encodeURIComponent(v)}`)).data); } catch (e) { console.error("search failed:", e); }
    }, 250);
  };
  const total = res ? GROUPS.reduce((n, [k]) => n + (res[k]?.length || 0), 0) : 0;

  return (
    <div className="relative">
      <MagnifyingGlass size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
      <input data-testid="global-search-input" value={q} onChange={(e) => run(e.target.value)}
        placeholder="Search customers, properties, equipment, jobs…"
        className="w-full h-11 pl-10 pr-3 rounded-xl border border-zinc-200 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-orange-200" />
      {res && (
        <div className="absolute z-50 mt-1 w-full bg-white border border-zinc-200 rounded-xl shadow-lg max-h-80 overflow-y-auto" data-testid="global-search-results">
          {total === 0 && <p className="p-3 text-sm text-zinc-400">No matches.</p>}
          {GROUPS.map(([key, label, fmt, to]) => (res[key]?.length ? (
            <div key={key} className="p-2">
              <p className="text-[10px] uppercase font-bold text-zinc-400 px-1">{label}</p>
              {res[key].map((r, i) => (
                <button key={r.id || i} data-testid={`search-${key}-${i}`}
                  onClick={() => { const t = to(r); if (t) { nav(t); setRes(null); setQ(""); } }}
                  className="w-full text-left px-2 py-1.5 rounded-lg hover:bg-zinc-50 text-sm text-zinc-800 truncate">{fmt(r)}</button>
              ))}
            </div>
          ) : null))}
        </div>
      )}
    </div>
  );
};
